const getters = {
    getUserToken: state => state.user.token,
    getUserInfo: state => state.user.userInfo,
    getcarnumber: state => state.user.carnumber,
    getCollectionArr: state => state.collectionArr.Arr,
    getCartArr: state => state.cartArr.Arr
}
export default getters


// WEBPACK FOOTER //
// ./src/store/getters.js